import { get, post, postExFile } from "@utils/httpUtil";
// 获取地区信息
export function getDictionaryTree(data, config) {
  return post(`${process.env.VUE_APP_DEPARTMENTlIST}/dict/getDictionaryTree`, data, config);
}
// 查询社区线下面诊服务开关配置
export function communityOfflineDiagnosisConsultGetConfig(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsult/getConfig`, data, config);
}
// 编辑社区线下面诊服务开关配置
export function communityOfflineDiagnosisConsultUpdateConfig(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsult/updateConfig`, data, config);
}
// 分页查询社区线下面诊服务管理列表-医生排班
export function communityOfflineDiagnosisConsultPageList(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsult/pageList`, data, config);
}
// 批量更新医生线下面诊服务显示状态
export function batchUpdateOfflineDiagnosisConsultStatus(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsult/batchUpdateOfflineDiagnosisConsultStatus`, data, config);
}
// 线下面诊服务管理列表-导出-医生排班
export function communityOfflineDiagnosisConsultExport(data, config) {
  return postExFile(`/c/pc/communityOfflineDiagnosisConsult/export`, data, config);
}
// 线下面诊出诊地列表查询
export function findVisitLocationListByCondition(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisVisitLocation/findVisitLocationListByCondition`, data, config);
}
// 添加线下面诊出诊地
export function addOfflineDiagnosisVisitLocation(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisVisitLocation/addOfflineDiagnosisVisitLocation`, data, config);
}
// 删除线下面诊出诊地
export function deleteOfflineDiagnosisVisitLocationById(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisVisitLocation/deleteOfflineDiagnosisVisitLocationById`, data, config);
}
// 修改线下面诊出诊地
export function updateOfflineDiagnosisVisitLocation(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisVisitLocation/updateOfflineDiagnosisVisitLocation`, data, config);
}
// 修改线下面诊出诊地上下架状态
export function updateOfflineDiagnosisVisitLocationStatus(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisVisitLocation/updateOfflineDiagnosisVisitLocationStatus`, data, config);
}
// 单个线下面诊出诊地查询
export function findVisitLocationById(data, config) {
  return get(`/c/pc/communityOfflineDiagnosisVisitLocation/findVisitLocationById`, data, config);
}
// 线下面诊出诊地医生设置列表分页查询
export function pageDoctorVisitLocationSetting(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisVisitLocation/pageDoctorVisitLocationSetting`, data, config);
}
// 设置社区出诊地医生价格
export function updateVisitLocationSetting(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisVisitLocation/updateVisitLocationSetting`, data, config);
}
// 批量设置社区出诊地医生价格
export function batchUpdateVisitLocationSetting(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisVisitLocation/batchUpdateVisitLocationSetting`, data, config);
}
// 分页查询线下面诊服务排班记录
export function pageSchedulePlan(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsultSchedulePlan/pageSchedulePlan`, data, config);
}
// 线下面诊服务管理排班列表-导出
export function communityOfflineDiagnosisConsultSchedulePlanExport(data, config) {
  return postExFile(`/c/pc/communityOfflineDiagnosisConsultSchedulePlan/export`, data, config);
}
// 作废排班记录
export function cancelSchedulePlan(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsultSchedulePlan/cancelSchedulePlan`, data, config);
}
// 线下面诊咨询分页查询-服务记录
export function serviceRecordFindPageConsult(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsult/findPageConsult`, data, config);
}
// 线下面诊咨询列表-导出-服务记录
export function serviceRecordExportConsult(data, config) {
  return postExFile(`/c/pc/communityOfflineDiagnosisConsult/exportConsult`, data, config);
}
// 新建医生排班
export function createDoctorSchedulePlan(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsultSchedulePlan/createDoctorSchedulePlan`, data, config);
}
// 新建医生排班-校验
export function createDoctorSchedulePlanCheck(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsultSchedulePlan/createDoctorSchedulePlan/check`, data, config);
}
// 查看医生排班详情
export function listScheduleByDoctor(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsultSchedule/listScheduleByDoctor`, data, config);
}
// 根据医生查询日程详情-出诊地下拉框
export function DoctorvisitLocationList(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsultSchedule/listScheduleByDoctor/visitLocationList`, data, config);
}
// 新建出诊地排班
export function createVisitLocationSchedulePlan(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsultSchedulePlan/createVisitLocationSchedulePlan`, data, config);
}
// 新建出诊地排班-校验
export function createVisitLocationSchedulePlanCheck(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsultSchedulePlan/createVisitLocationSchedulePlanCheck`, data, config);
}
// 查看出诊地排班详情
export function listScheduleByVisitLocation(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsultSchedule/listScheduleByVisitLocation`, data, config);
}
// 根据排班记录id查看排班记录详情
export function getSchedulePlanById(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsultSchedulePlan/getSchedulePlanById`, data, config);
}
// 查看排班记录关联的出诊地列表
export function getSchedulePlanVisitLocationList(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsultSchedulePlan/getSchedulePlanVisitLocationList`, data, config);
}
// 作废排班记录明细
export function cancelSchedulePlanDetail(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsultSchedulePlan/cancelSchedulePlanDetail`, data, config);
}
// 线下面诊出诊地名称校验
export function checkVisitLocationNameAvailable(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisVisitLocation/checkVisitLocationNameAvailable`, data, config);
}
// 根据出诊地查询日程详情-医生下拉框
export function VisitLocationDoctorList(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsultSchedule/listScheduleByVisitLocation/doctorList`, data, config);
}
// 查询医生线下面诊服务设置
export function getDoctorSetting(data, config) {
  return post(`/c/pc/communityOfflineDiagnosisConsultSchedulePlan/getDoctorSetting`, data, config);
}